import WritingCompetitionLayout from "./WritingCompetitionLayout";

export default WritingCompetitionLayout;